export const api = {
  stockistListing: '/stockist-list',
  stockistCreateUpdate: '/stockist',
  loadExistingStockist: '/stockist-details',
  loadStockistOrderReturnListing: '/consignment-order-return-list',
  stockistConsignmentOrderReturn: '/consignment-order-return',
  loadExistingConsignmentOrderReturn: '/consignment-order-return-details',
  stockistConsignmentDeposit: '/consignment-deposit',
  stockistConsignmentRefund: '/consignment-refund',
  loadStockistDepositSettings: '/consignment-deposit-refund-validate',
  stockistDepositReturnListing: '/consignment-deposit-refund-list',
  loadExistingStockistDepositRefund: '/consignment-deposit-refund-details',
  loadStockistDailyTransactionList: '/stockist-daily-invoice-transaction-list',
  batchReleaseStockistInvoice: '/batch-release-stockist-daily-invoice-transaction',
  downloadConsignmentOrderReturnNote: '/consignment/downloadpdf',
  stockistReturnProductSearch: '/consignment-return-product-validate',
  stockistEligibleReturnCheck: '/consignment-return-validate',
  stockistARSummary: '/stockist-outstanding-summary',
  stockistPaymentVerificationList: '/stockist-daily-sale-payment-verification-list',
  stockistPaymentVerificationUpdate: '/stockist-daily-sale-payment-verification-update',
  dailyCollectionReport: '/daily-collection-report',
  consignmentDepositRefundNote: '/download-consignment-deposit-receipt',
  stockistConsignmentStockReport: '/stockist-consignment-stock-report',
  stockistConsignmentStockReportByCountry: '/stockist-consignment-stock-report-by-country',
  stockistConsignmentCalculateBalance: '/calculate-consignment-balance',
}
